export default __webpack_public_path__ + "static/media/img15.21fbebe2.jpeg";